import React, { useState } from "react";
import {
  Typography,
  Box,
  Stack,
  Tooltip,
  IconButton,
  Button,
  Collapse,
} from "@mui/material";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import CustomButton from "../../utility-v1/Button"; // adjust the path as needed

const upiIDs = ["ammujgd@oksbi", "ammujgd@okicici", "7306228716@ybl"];
const whatsappNumber = "7907448913";

const GPayInline = ({ form, smsTracking, onEditAddress }) => {
  const [copiedText, setCopiedText] = useState(null);
  const [showBankDetails, setShowBankDetails] = useState(false);

  const buyerName = form?.name?.trim() || "Customer";
  const nameWithSales = `${buyerName} (${smsTracking})`;

  const copyToClipboard = async (text) => {
    try {
      if (navigator.clipboard && window.isSecureContext) {
        await navigator.clipboard.writeText(text);
      } else {
        const textarea = document.createElement("textarea");
        textarea.value = text;
        textarea.style.position = "fixed";
        textarea.style.opacity = "0";
        document.body.appendChild(textarea);
        textarea.focus();
        textarea.select();
        document.execCommand("copy");
        document.body.removeChild(textarea);
      }

      setCopiedText(text);
      setTimeout(() => setCopiedText(null), 2000);
    } catch (error) {
      console.error("Failed to copy:", error);
      alert("Copy failed. Please long-press and copy manually.");
    }
  };

  return (
    <Box sx={{ mx: "auto" }}>
      <Typography sx={{ fontSize: "16px", color: "black", fontWeight: "bold",marginBottom:"10px" }}>
        Your Order Id is {smsTracking}
      </Typography>
      <Typography sx={{ color: "green", mb: 2, fontSize: "18px" }}>
        Complete your payment and we’ll get your order ready for shipping right
        away.
      </Typography>

      {form?.price && (
        <Box
          sx={{
            mb: 2,
            display: "flex",
            justifyContent: "space-between",
            alignItems: "flex-start",
            flexWrap: "wrap",
            gap: 2,
          }}
        >
          {/* Payment Info */}
          <Box sx={{ flexShrink: 0 }}>
            <Typography
              sx={{
                fontSize: "16px",
                color: "black",
                mb: 0.4,
                fontWeight: "bold",
              }}
            >
              Payment Amount
            </Typography>
            <Typography
              sx={{ fontSize: "24px", fontWeight: "bold", color: "#2e7d32" }}
            >
              ₹{form.price}
            </Typography>
          </Box>

          {/* Buttons stacked on right side */}
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-end", // align buttons right
              flexShrink: 0,
              ml: "auto", // push to right
            }}
          >
            <Button
              size="small"
              variant="outlined"
              color="secondary"
              onClick={onEditAddress}
              sx={{ fontSize: "13px", px: 2 }}
            >
              Edit Address
            </Button>
          </Box>
        </Box>
      )}

      {/* Pay by Phone */}
      <Box
        sx={{
          border: "1px solid #ccc",
          borderRadius: "8px",
          backgroundColor: "#fff",
          padding: "16px",
          mb: 2,
          position: "relative",
        }}
      >
        <Typography
          sx={{
            position: "absolute",
            top: "-11px",
            left: "12px",
            backgroundColor: "#fff",
            fontSize: "14px",
            fontWeight: 600,
            color: "#1976d2",
            borderRadius: "4px",
            zIndex: 1,
          }}
        >
          Use GPay, PhonePe or any UPI app
        </Typography>

        {/* Phone number row */}
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          sx={{ mb: 1.5 }} // spacing below phone number
        >
          <Typography sx={{ fontSize: "16px", fontWeight: 500 }}>
            Phone Number: <strong>7306228716</strong>
          </Typography>
          <Box
            onClick={() => copyToClipboard("7306228716")}
            sx={{
              fontSize: "13px",
              color: "black",
              fontWeight: "bold",
              cursor: "pointer",
            }}
          >
            {copiedText === "7306228716" ? "Copied!" : "Click to copy"}
          </Box>
        </Stack>

        {/* Spacer text */}

        {/* UPI list */}
        <Stack spacing={1.5} sx={{ mb: 1.5 }}>
          {upiIDs.map((upi) => (
            <Box
              key={upi}
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <Typography sx={{ fontSize: "16px", letterSpacing: "1px" }}>
                {upi}
              </Typography>
              <Box
                onClick={() => copyToClipboard(upi)}
                sx={{
                  fontSize: "13px",
                  color: "black",
                  fontWeight: "bold",
                  cursor: "pointer",
                }}
              >
                {copiedText === upi ? "Copied!" : "Click to copy"}
              </Box>
            </Box>
          ))}
        </Stack>

        {/* Verified name */}
        <Typography sx={{ fontSize: "14px" }}>
          Verified Name:{" "}
          <Box component="span" sx={{ fontWeight: "bold", color: "green" }}>
            ANJANA ASOK
          </Box>
        </Typography>
      </Box>

      {/* Net Banking - Collapsible */}
      <Box sx={{ mb: 2 }}>
        <Button
          fullWidth
          variant="outlined"
          color="success"
          endIcon={showBankDetails ? <ExpandLessIcon /> : <ExpandMoreIcon />}
          onClick={() => setShowBankDetails(!showBankDetails)}
          sx={{
            justifyContent: "space-between",
            textTransform: "none",
            fontWeight: "bold",
          }}
        >
          Net Banking Details
        </Button>

        <Collapse in={showBankDetails}>
          <Box
            sx={{
              border: "1px solid #ccc",
              borderRadius: "8px",
              backgroundColor: "#f1f8e9",
              padding: "12px 16px",
              mt: 1,
            }}
          >
            <Stack spacing={0.5}>
              <Typography>
                <strong>A/C Holder Name:</strong> Anjana Asok
              </Typography>
              <Typography>
                <strong>A/C Number:</strong> 021201530345
              </Typography>
              <Typography>
                <strong>IFSC Code:</strong> ICIC0000212
              </Typography>
              <Typography>
                <strong>Branch:</strong> RK MuttRoad, Chennai
              </Typography>
            </Stack>
          </Box>
        </Collapse>
      </Box>

      <Box sx={{ mb: 2 }}>
        <Button
          size="small"
          variant="outlined"
          color="success"
          startIcon={<WhatsAppIcon />}
          href={`https://wa.me/91${whatsappNumber}?text=Hi, this is ${nameWithSales}, I need help with the payment.`}
          target="_blank"
          rel="noopener noreferrer"
          sx={{ fontSize: "13px", px: 2 }}
        >
          Need help
        </Button>
      </Box>

      {/* WhatsApp Confirmation */}
      <Typography
        variant="subtitle1"
        sx={{ fontSize: "15px", fontWeight: 600, mb: 1, color: "black" }}
      >
        After payment, share your UPI ID or screenshot on WhatsApp below.
      </Typography>
      <Box sx={{ display: "flex", gap: 2, flexWrap: "wrap", mt: 2 }}>
        <Button
          variant="contained"
          color="success"
          startIcon={<WhatsAppIcon />}
          href={`https://wa.me/91${whatsappNumber}?text=Hi, this is ${nameWithSales}, I have completed the payment. Here is my UPI transaction ID:`}
          target="_blank"
          rel="noopener noreferrer"
          sx={{ fontSize: "13px", px: 2 }}
        >
          Share on WhatsApp
        </Button>
      </Box>
    </Box>
  );
};

export default GPayInline;
